import React from "react";
import { useSelector } from "react-redux";
import { BulkPreviewButton }  from "./BulkPreviewButton";
import { BulkApprovalButton }  from "./BulkApprovalButton";
import { BulkActionsButton }  from "./BulkActionsButton";
import BulkDecisioningButton from "./BulkVersionsButton";

export default function BulkActions(props){
	const { currentSelection } = useSelector(state => ({
		currentSelection: state.selected[props.type],
	}));

	if(!currentSelection || currentSelection.length === 0) { return null; }

	return (
		<div className="bulk-actions flex-center">
			<BulkPreviewButton />
			<BulkApprovalButton />
			<BulkDecisioningButton />
			<BulkActionsButton />
		</div>
	);
}

BulkActions.displayName = "BulkActions";
